// extracted by mini-css-extract-plugin
export default {"avatar":"UpmRDVh7","circular":"fKi_njBo"};